import {PullRequestState} from '../../types'
import {isPullRequestOpenState} from '../../utils/pull-request-state'

/**
 * Determines if a pull request is in a reviewable state.
 * Reviewable states are: OPEN, DRAFT, QUEUED, and MERGED.
 * Closed and archived PRs are considered non-reviewable.
 *
 * Review after merged is a feature that allows users to submit reviews on pull requests that have already been merged.
 * Users have indicated value in retroactive reviews as signals of confidence in the code that was merged.
 */
export function isReviewablePullRequestState(state: PullRequestState) {
  return isPullRequestOpenState(state) || state === PullRequestState.Merged
}
